import { RAD, clamp } from './constants.js';
import { presentInScene, targetWorldPoint } from './sceneObjects.js';

export const PLATE_DEFAULTS = { text: 'SL 2048', width: 0.52, height: 0.11, mountHeight: 0.6,
  front: true, rear: true, rearYellow: false, speedKph: 0, minPixels: null, maxBlurPx: 2 };

export function plateSettings(object, S, legacy = false) {
  return { ...PLATE_DEFAULTS, ...(legacy ? { mountHeight: S?.opt.hPlate ?? 0.6 } : {}), ...object.plate };
}

/** Shared physical positions for plate meshes, sample rays and camera crops.
 * Plate dimensions are independent of car scaling, constrained only by its hull. */
export function vehiclePlates(S, object, source = 'obstacle') {
  const legacy = source === 'target', p = plateSettings(object, S, legacy);
  if (!legacy && !presentInScene(object, S?.sceneState)) return [];
  const length = legacy ? 4.4 : object.width, depth = legacy ? 1.8 : object.depth, carHeight = legacy ? 1.5 : object.height;
  const width = Math.min(p.width, depth * 0.9), height = Math.min(p.height, carHeight * 0.8);
  const mountHeight = clamp(p.mountHeight, height / 2, carHeight - height / 2);
  return ['front', 'rear'].filter(side => p[side]).map(side => {
    const sign = side === 'front' ? 1 : -1, x = sign * (length / 2 + 0.012);
    const centre = targetWorldPoint(object, x, 0, (legacy ? 0 : object.bottom || 0) + mountHeight);
    return { ...p, x: centre.x, y: centre.y, heightAboveGround: centre.height, width, height, localX: x, localHeight: mountHeight,
      heading: ((object.pan || 0) + (side === 'rear' ? 180 : 0) + 360) % 360,
      travelHeading: object.pan || 0, side, source, vehicleId: object.id,
      key: `${source}:${object.id}:${side}`, name: `${object.name || 'Vehicle'} · ${side} plate` };
  });
}

export function scenePlates(S) {
  return [...(S.obstacles || []).filter(o => o.kind === 'vehicle').flatMap(o => vehiclePlates(S, o)),
    ...(S.targets || []).filter(o => o.kind === 'vehicle').flatMap(o => vehiclePlates(S, o, 'target'))];
}

// Corners clockwise as seen from the front of the plate.
export function plateCorners(plate) {
  const a = plate.heading * RAD;
  return [[-0.5, 0.5], [0.5, 0.5], [0.5, -0.5], [-0.5, -0.5]].map(([u, v]) => ({
    x: plate.x + Math.sin(a) * plate.width * u,
    y: plate.y - Math.cos(a) * plate.width * u,
    height: plate.heightAboveGround + plate.height * v
  }));
}
